import { Injectable, EventEmitter } from "@angular/core";
import {
  SignalRService,
  SignalREventService,
  Classification,
  DataArray,
  ToastrService,
  GlobalService,
} from "./../index";

@Injectable()
export class ClassificationService {
  public classificationChange: EventEmitter<Classification[]> =
    new EventEmitter<Classification[]>();

  public classifications: DataArray<Classification> =
    new DataArray<Classification>();

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _toastrService: ToastrService,
    private _GlobalService: GlobalService
  ) {
    this.registerOnServerEvents();
  }

  public create(classification: string): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "CreateClassification",
              classification,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "CreateClassification",
              classification,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }

  public getUseCount(classificationId: number): Promise<number> {
    return this._signalRService
      .invoke("GetClassificationUseCount", classificationId)
      .then((result: number) => {
        return result;
      });
  }
  public getUseCountStaged(classificationId: number): Promise<number> {
    return this._signalRService
      .invoke("GetClassificationUseCountStaged", classificationId)
      .then((result: number) => {
        return result;
      });
  }

  public getClassifications(): void {
    this._signalRService.invoke("GetClassifications");
  }
  public getClassificationsStaged(): void {
    this._signalRService.invoke("GetClassificationsStaged");
  }

  private onClassifications(info: any): void {
    this.classifications.init();

    for (const item of info.Data.Classifications) {
      const classification: Classification = $.extend(
        new Classification(),
        item
      );
      this.classifications.push(classification);
    }

    this.classificationChange.emit(this.classifications.Data);
  }

  private onNewClassification(info: any): void {
    this.classifications.update(
      $.extend(new Classification(), info.Data.Classification),
      true
    );
    this._toastrService.displayToastrMessage(
      "success",
      "Classification " + info.Data.Classification.Name + " created!",
      "Create Classification"
    );
    this.classificationChange.emit(this.classifications.Data);
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "ClassificationService",
      "classifications",
      (info: any) => this.onClassifications(info)
    );
    this._signalREventService.register(
      "ClassificationService",
      "newClassification",
      (info: any) => this.onNewClassification(info)
    );
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("ClassificationService");
  }
}
